const hexBaseRadix = 16;

export const randomUUID = <T>(arr: T[]): T[] =>
  arr?.map((elem) => ({
    ...elem,
    uuid: '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, () =>
      crypto.getRandomValues(new Uint8Array(1))[0].toString(hexBaseRadix),
    ),
  }));
